import { IRootReducer } from 'redux/rootReducer'

export const getNotification = (state: IRootReducer) =>
  state.application.notification

export const getTempValue = (state: IRootReducer) => state.application.temp

export const isActive = (state: IRootReducer) => state.application.isActive
export const isOnline = (state: IRootReducer) => state.application.isOnline
